var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { getUniqueSeparatedStringsFromTextField } from '../../../../utils/textField_helper';
import { QuickStartForm } from './QuickStartForm';
import { useDispatch } from 'react-redux';
import { createImmediateOneTimeBudget } from '../utils/budget_helper';
import { addTeamAccountBudget } from '../../../MealBudgets/budgets_slice';
import { useAddTeamMembersToTeamAccountMutation } from '../../../Employees/useAddTeamMembersToTeamAccountMutation';
import track from '../../../../utils/track';
import { OnboardingEvents } from '../../../../constants/events';
import { SetupOptionId } from '../EmOnboardingPageData';
var quickStartExpireInSeconds = 24 * 60 * 60; // 24 hours to seconds
var QuickStart = function (_a) {
    var hidePaymentMethod = _a.hidePaymentMethod, teamAccountId = _a.teamAccountId, onBack = _a.onBack, completeOnboarding = _a.completeOnboarding;
    var dispatch = useDispatch();
    var _b = __read(React.useState(false), 2), isProcessingForm = _b[0], setIsProcessingForm = _b[1];
    var addTeamMembersToTeamAccount = useAddTeamMembersToTeamAccountMutation().addTeamMembersToTeamAccount;
    var handleFormSubmit = function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsProcessingForm(true);
                    // In this step, payment is already validated
                    // so we only have to create budget and add members (if necessary)
                    return [4 /*yield*/, handleCreateBudget(formValues.budgetName, formValues.budgetAmount)
                        // TODO: Add Error Handling
                    ];
                case 1:
                    // In this step, payment is already validated
                    // so we only have to create budget and add members (if necessary)
                    _a.sent();
                    // TODO: Add Error Handling
                    completeOnboarding();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCreateBudget = function (budgetName, budgetAmount) { return __awaiter(void 0, void 0, void 0, function () {
        var budgetAmountInCents, budgetObj, response, budgetId, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    budgetAmountInCents = Math.floor(budgetAmount * 100) // only consider 2 decimal places
                    ;
                    budgetObj = createImmediateOneTimeBudget({
                        name: budgetName,
                        teamAccountId: teamAccountId,
                        budgetAmountInCents: budgetAmountInCents,
                        expireDaysInSeconds: quickStartExpireInSeconds,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(addTeamAccountBudget(budgetObj)).unwrap()];
                case 2:
                    response = _b.sent();
                    budgetId = response.id;
                    track(OnboardingEvents.CREATE_BUDGET_SUCCESS, {
                        setup: SetupOptionId.quickStart,
                        budget_id: budgetId,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    track(OnboardingEvents.CREATE_BUDGET_FAILURE, {
                        setup: SetupOptionId.quickStart,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleAddMembers = function (membersFormValue) { return __awaiter(void 0, void 0, void 0, function () {
        var membersArray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    membersArray = getUniqueSeparatedStringsFromTextField(membersFormValue);
                    if (!(membersArray === null || membersArray === void 0 ? void 0 : membersArray.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, addTeamMembersToTeamAccount(teamAccountId, membersArray, {
                            onCompleted: function (response) {
                                // TODO: Error Handling?
                                return response;
                            },
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, ''];
            }
        });
    }); };
    return (React.createElement(QuickStartForm, { teamAccountId: teamAccountId, hidePaymentMethod: hidePaymentMethod, isProcessingForm: isProcessingForm, handleFormSubmit: handleFormSubmit, onBack: onBack }));
};
export default QuickStart;
